<template>
  <div class="drawer-form-action">
    <a-button
      style="margin-right: 8px"
      @click="cancel"
    >
      {{ $t('shared.cancel') }}
    </a-button>
    <a-button
      type="primary"
      :loading="loading"
      @click="$emit('save')"
    >
      {{ $t('shared.editDialog.ok') }}
    </a-button>
  </div>
</template>

<script>
import { createVNode } from 'vue'
import { ExclamationCircleOutlined } from '@ant-design/icons-vue'
import { Modal } from 'ant-design-vue'
import { useI18n } from 'vue-i18n'

export default {
  props: {
    canClose: {
      type: Boolean,
      required: true
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  emits: [
    'save',
    'cancel'
  ],
  setup (props, { emit }) {
    const { t } = useI18n()

    function cancel () {
      if (props.canClose) {
        emit('cancel')
      } else {
        Modal.confirm({
          icon: createVNode(ExclamationCircleOutlined),
          content: t('shared.editDialog.cancelWarning'),
          onOk: () => emit('cancel')
        })
      }
    }

    return {
      cancel
    }
  }
}
</script>
